/* eslint-disable no-unused-vars */
import { ReactComponent as TwitterIcon } from "images/twitter-icon.svg";
import { ReactComponent as FacebookIcon } from "images/facebook-icon.svg";
import { ReactComponent as VitIcon } from "feather-icons/dist/icons/link.svg";
import { ReactComponent as InstaIcon } from "images/insta.svg";
import { ReactComponent as LinkedinIcon } from "images/linkedin.svg";

export const dep = [
  {
    posts: "270",
    dep: "Exam Department",
    summary: "All Exam Material is here",
  },
  {
    posts: "007",
    dep: "Internship Department",
    summary: "All Internship Details are here",
  },
  {
    posts: "123",
    dep: "Carrer Counselling",
    summary: "Need help in deciding CARRER?",
  },
  {
    posts: "027",
    dep: "Student Achievement",
    summary: "All Students Achievements are here",
  },
  {
    posts: "323",
    dep: "Faculty Achievement",
    summary: "All Faculty Achievements are here",
  },
  {
    posts: "342",
    dep: "ITSA",
    // summary: "All Faculty Achievements are here",
  },
  {
    posts: "012",
    dep: "DSC",
    // summary: "All Faculty Achievements are here",
  },
  {
    posts: "043",
    dep: "ACM",
    // summary: "All Faculty Achievements are here",
  },
];

export const cards = [
  {
    imageSrc:
      "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=2.95&w=512&h=512&q=80",
    position: "Founder",
    name: "Adam Cuppy",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
      // {
      //   url: "https://github.com",
      //    icon: GithubIcon,
      // },
    ],
  },
  {
    imageSrc:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=2.95&w=512&h=512&q=80",
    position: "Sr. Designer",
    name: "Charlotte Hale",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc:
      "https://images.unsplash.com/photo-1517070208541-6ddc4d3efbcb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=2.95&w=512&h=512&q=80",
    position: "Jr. Designer",
    name: "Silvester Wize",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc:
      "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=2.95&w=512&h=512&q=80",
    position: "Lead Developer",
    name: "Himali Turn",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc:
      "https://images.unsplash.com/photo-1546820389-44d77e1f3b31?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=3.45&w=512&h=512&q=80",
    position: "Sr. Developer",
    name: "Troye Sivan",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=3.45&w=512&h=512&q=80",
    position: "Quality Assurance",
    name: "Holo Wo",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc: require("../images/Faculty/DrVipulDalal.jpg").default,
    position: "Head of the Department",
    name: "Dr. Vipul Dalal",
    links: [
      {
        url: "https://www.linkedin.com/in/drvipuldalal/",
        icon: LinkedinIcon,
      },

      {
        url: "https://instagram.com",
        icon: InstaIcon,
      },
      {
        blink: true,
        url: "https://www.vit.edu.in/VipulDalal.html",
        icon: VitIcon,
      },
    ],
  },
  {
    imageSrc: require("../images/Faculty/RohitBarve.png").default,
    position: "Assistant Professor",
    name: "Rohit Barve",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
      {
        blink: true,
        url: "https://www.vit.edu.in/RohitBarve.html",
        icon: VitIcon,
      },
    ],
  },
  {
    imageSrc: require("../images/Faculty/SantoshTamboli.png").default,
    position: "Assistant Professor",
    name: "Santosh Tamboli",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
      {
        blink: true,
        url: "https://www.vit.edu.in/SantoshTamboli.html",
        icon: VitIcon,
      },
    ],
  },
  {
    imageSrc: require("../images/Faculty/VinitaBhandiwad.png").default,
    position: "Assistant Professor",
    name: "Vinita Bhandiwad",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
      {
        blink: true,
        url: "https://www.vit.edu.in/VinitaBhandiwad.html",
        icon: VitIcon,
      },
    ],
  },
  {
    imageSrc: require("../images/Faculty/YashShah.png").default,
    position: "Assistant Professor",
    name: "Yash Shah",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
      {
        blink: true,
        url: "https://www.vit.edu.in/YashShah.html",
        icon: VitIcon,
      },
    ],
  },
  {
    imageSrc: require("../images/Faculty/IchhanshuJaiswal.png").default,
    position: "Assistant Professor",
    name: "Ichhanshu Jaiswal",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
      {
        blink: true,
        url: "https://www.vit.edu.in/IchhanshuJaiswal.html",
        icon: VitIcon,
      },
    ],
  },
  {
    imageSrc:
      "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=2.95&w=512&h=512&q=80",
    position: "Founder",
    name: "Adam Cuppy",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
      // {
      //   url: "https://github.com",
      //    icon: GithubIcon,
      // },
    ],
  },
  {
    imageSrc:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=2.95&w=512&h=512&q=80",
    position: "Sr. Designer",
    name: "Charlotte Hale",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc:
      "https://images.unsplash.com/photo-1517070208541-6ddc4d3efbcb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=2.95&w=512&h=512&q=80",
    position: "Jr. Designer",
    name: "Silvester Wize",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc:
      "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=2.95&w=512&h=512&q=80",
    position: "Lead Developer",
    name: "Himali Turn",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc:
      "https://images.unsplash.com/photo-1546820389-44d77e1f3b31?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=3.45&w=512&h=512&q=80",
    position: "Sr. Developer",
    name: "Troye Sivan",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
    ],
  },
  {
    imageSrc:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=3.45&w=512&h=512&q=80",
    position: "Quality Assurance",
    name: "Holo Wo",
    links: [
      {
        url: "https://twitter.com",
        //  icon: TwitterIcon,
      },
      {
        url: "https://linkedin.com",
        //  icon: LinkedinIcon,
      },
    ],
  },
];
